<template>
  <div class="tool-box-container" ref="tool-box-container">
    <div class="tool-box-row">
      <div class="tool tools-container white-background">
        <div class="tool-description"><span>Narzędzie</span></div>
        <div class="tool-elements">
          <!-- <b-tooltip content="Pędzel" -->
          <tr-toolbox-tool
            image="przybornik_pedzel"
            :title="getTooltips['przybornik_pedzel']"
            :tool="tools[0]"
          ></tr-toolbox-tool>
          <!-- </b-tooltip> -->
          <!-- <b-tooltip content="Prostokątny obszar" -->
          <tr-toolbox-tool
            image="przybornik_prostokat"
            :title="getTooltips['przybornik_prostokat']"
            :tool="tools[1]"
          ></tr-toolbox-tool>
          <!-- </b-tooltip> -->
          <!-- <b-tooltip content="Eliptyczny obszar" -->
          <tr-toolbox-tool
            image="przybornik_okrag"
            :title="getTooltips['przybornik_okrag']"
            :tool="tools[2]"
          ></tr-toolbox-tool>
          <!-- </b-tooltip> -->
          <!-- <b-tooltip content="Wyróżnij obszar" -->
          <tr-toolbox-tool
            image="przybornik_wyroznij"
            :title="getTooltips['przybornik_wyroznij']"
            :tool="tools[4]"
          ></tr-toolbox-tool>
          <!-- </b-tooltip> -->
          <!-- <b-tooltip content="Gumka" -->
          <tr-toolbox-tool
            image="przybornik_gumka"
            :title="getTooltips['przybornik_gumka']"
            :tool="tools[3]"
          ></tr-toolbox-tool>
          <!-- </b-tooltip> -->
          <!-- <b-tooltip content="Wyczyść wszystko" -->
          <div class="clearAll" :title="getTooltips['clearAll']" @click="clearAll()"></div>
          <!-- </b-tooltip> -->
        </div>
      </div>
      <div class="sizes tools-container white-background">
        <div class="tool-description"><span>Rozmiar</span></div>
        <div class="tool-elements">
          <tr-toolbox-size image="przybornik_wielkosc1" :size="sizes[0]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc2" :size="sizes[1]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc3" :size="sizes[2]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc4" :size="sizes[3]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc5" :size="sizes[4]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc6" :size="sizes[5]"></tr-toolbox-size>
          <tr-toolbox-size image="przybornik_wielkosc7" :size="sizes[6]"></tr-toolbox-size>
        </div>
      </div>
      <div class="colors tools-container white-background">
        <div class="tool-description"><span>Kolor</span></div>
        <div class="tool-elements tool-colors-container">
          <!-- <b-tooltip content="Wybrany kolor" -->
          <div class="selected-color" :title="getTooltips['wybranyKolor']">
            <tr-toolbox-color :color="color"></tr-toolbox-color>
          </div>
          <!-- </b-tooltip> -->
          <div class="colors-container">
            <div class="color-row">
              <tr-toolbox-color :color="colors[0]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[1]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[2]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[3]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[4]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[5]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[6]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[7]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[8]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[9]"></tr-toolbox-color>
            </div>
            <div class="color-row">
              <tr-toolbox-color :color="colors[10]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[11]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[12]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[13]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[14]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[15]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[16]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[17]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[18]"></tr-toolbox-color>
              <tr-toolbox-color :color="colors[19]"></tr-toolbox-color>
            </div>
          </div>
        </div>
      </div>
      <!-- <b-tooltip content="Zamknij przybornik" -->
      <div
        class="exit"
        v-if="!mbciwdState && checkGameEngine()"
        :title="getTooltips['exit']"
        @click="toolboxExit"
      ></div>
      <!-- </b-tooltip> -->
    </div>
  </div>
</template>
<script>
// import SystemInformation from './LandingPage/SystemInformation';
import TrToolboxSize from './SubComponents/TrToolboxSize';
import TrToolboxColor from './SubComponents/TrToolboxColor';
import TrToolboxTool from './SubComponents/TrToolboxTool';
export default {
  name: 'tr-canvas-toolbox',
  data: function () {
    return {
      tools: [],
      sizes: [],
      colors: [],
    };
  },
  components: {
    TrToolboxSize,
    TrToolboxColor,
    TrToolboxTool,
  },
  mounted: function () {
    this.tools = this.$store.getters.allTools;
    this.sizes = this.$store.getters.allSizes;
    this.colors = this.$store.getters.allCollors;
    this.$store.commit('CHANGE_CANVAS_TOOLL', 'paintBrush');
  },
  methods: {
    checkGameEngine() {
      if (this.gameData.item) {
        if (this.gameData.item.engine == 'croppImg') {
          return false;
        } else return true;
      } else return true;
    },
    toolboxExit() {
      if (this.$store.getters.mbciwdActive) {
        this.clearAll();
      }
      this.$store.commit('CHANGE_MBCIWD_ACTIVE', false);
      // this.$store.commit( 'TOGGLE_CANVAS_ACTIVE', this.canvasActive );
      this.$store.commit('TOGGLE_CANVAS');
      this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      // this.$store.commit( 'TOGGLE_UI_DISABLE', true );
      this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      this.$store.commit('TOGGLE_UI_DISABLE', !this.allTopLayoutDisable);
    },
    clearAll() {
      this.$parent.$parent.$emit('clearCanvas');
      this.$store.commit('CHANGE_MBCROPPIMGCANVAS_ACTIVE', false);
      setTimeout(() => {
        this.$store.commit('CHANGE_MBCROPPIMGCANVAS_ACTIVE', true);
      }, 500);
    },
  },
  computed: {
    gameData() {
      return this.$store.getters.gameData;
    },
    mbciwdState() {
      return this.$store.getters.mbciwdActive;
    },
    color() {
      return this.$store.getters.toolColor;
    },
    canvasActive() {
      return this.$store.getters.canvasActive;
    },
    allTopLayoutDisable() {
      return this.$store.getters.allTopLayoutDisable;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.tool-box-container {
  position: relative;
  top: 0;
  left: 0;
  z-index: 9999 !important;
  cursor: pointer;
  display: flex;
  justify-content: center;
  .white-background {
    background-color: #ffffff;
  }
  .tool-box-row {
    border-top: 5px solid #f2f2f2;
    border-right: 5px solid #f2f2f2;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    // height: $toolboxHeight;
    .tools-container {
      display: flex;
      flex-direction: column;
      .tool-description {
        display: flex;
        justify-content: center;
        align-content: center;
        span {
          font-size: 1rem;
        }
      }
      .tool-elements {
        display: flex;
        flex-direction: row;
        margin-left: 15px;
        .clearAll {
          width: $toolboxBigIcon * 80/100;
          height: $toolboxBigIcon * 80/100;
          background-image: url('~@/assets/icons/book/toolbox/przybornik_kosz.png');
          background-size: contain;
          background-repeat: no-repeat;
          -webkit-font-smoothing: subpixel-antialiased;
          backface-visibility: hidden;
          cursor: pointer;
          &:hover {
            box-shadow: inset 0 0 12px 3px $canvasActive;
          }
        }
        .selected-color {
          display: flex;
          margin-left: 10px;
          margin-right: 10px;
        }
        .colors-container {
          display: flex;
          flex-direction: column;
          .color-row {
            display: flex;
            // margin-bottom: 4px;
          }
        }
      }
    }
    .colors,
    .exit,
    .sizes,
    .tool {
      display: flex;
      padding-right: 20px;
      margin-left: 15px;
    }
  }
  .exit {
    width: $toolboxBigIcon * 80/100;
    height: $toolboxBigIcon * 80/100;
    background-image: url('~@/assets/icons/book/toolbox/przybornik_zakoncz.png');
    background-size: contain;
    background-repeat: no-repeat;
    -webkit-font-smoothing: subpixel-antialiased;
    backface-visibility: hidden;
  }
}
</style>
